export default {
  dialog: {
    header: {
      notes: 'Header in account selection dialog',
      message: 'Accounts',
    },
  },
  viewingAs: {
    notes: 'Label showing which company user is showing information as',
    message: 'Viewing as',
  },
  action: {
    actAsYourself: {
      notes: 'Title of action to go back to act as yourself',
      message: 'Go back to viewing as myself',
    },
  },
};
